import { Box, Grid, useMediaQuery, useTheme } from "@material-ui/core";
import React from "react";
import SingleItem from "../LandingPageFeature/LandingPageFeature";
import secure from "../../../assets/staticAssets/01.svg";
import support from "../../../assets/staticAssets/02.svg";
import charges from "../../../assets/staticAssets/03.svg";
import { makeStyles } from "@material-ui/styles";
import TransparentFlexBox from "../TransparentFlexBox/TransparentFlexBox";
import EndCredits from "../EndCredits/EndCredits";
import earn from "../../../assets/staticAssets/earn_2.svg";
import googleplay from "../../../assets/staticAssets/googleplay.png";
import Img from "react-cool-img";

function LandingPageFifthRow() {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const sm_matches = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <div className="md:pb-16">
        <div className="container-bt">
          <div className="flex justify-between flex-wrap items-center">
            <div className="md:w-[40%] w-full leading-relaxed">
              <h1 className="font-extrabold">Trading made Easy</h1>
              <br></br>
              <p
                className="mb-8 font-light text-lg md:text-xl leading-loose "
                style={{ color: "#ccc" }}
              >
                All of your{" "}
                <span className="text-pb-primary-100">Portfolio</span> now
                literally in your pocket! Trade, earn & monitor everyting with
                our Mobile Apps.
              </p>
              <h2 className="mb-4">Download the App Now!</h2>
              <div className="flex items-center">
                <img
                  className={
                    "cursor-pointer hover:opacity-70 transition-all mr-3"
                  }
                  src={googleplay}
                  alt="googleplay"
                  style={{ height: "50px", marginRight: "50px" }}
                  onClick={() => {
                    window.open(
                      "https://play.google.com/store/apps/details?id=com.pocketbits",
                      "_blank"
                    );
                  }}
                />{" "}
                <Img
                  style={{ height: "50px", marginRight: "50px" }}
                  src={
                    require("../../../assets/optimized/Landing/Footer/iosAppStore.svg")
                      .default
                  }
                />
              </div>
            </div>
            <div className="md:w-[50%]">
              <Img
                className=" md:max-w-[500px] w-full "
                src={
                  require("../../../assets/optimized/Landing/App Section/appSectionImage2x.png")
                    .default
                }
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const useStyles = makeStyles((theme) => ({}));

export default LandingPageFifthRow;
